import { Component, OnInit } from '@angular/core';

import { Calldto, Voicemaildto } from '../../generated/eveportal-api/graphql';
import { CallHistoryService } from '../services/call-history.service';

@Component({
  selector: 'app-call-history',
  templateUrl: './call-history.component.html',
  styleUrls: ['./call-history.component.css'],
})
export class CallHistoryComponent implements OnInit {
  historyItems: (Calldto | Voicemaildto)[] = [];
  limit = 20;

  since?: number;
  olderThan?: number;

  // for controlling pagination
  pageStack: { since?: number; olderThan?: number }[] = [];
  filters: string[] = [];

  constructor(private callHistoryService: CallHistoryService) {}

  ngOnInit() {
    this.loadInitial();
  }

  loadInitial() {
    this.callHistoryService
      .getCallHistory({
        limit: this.limit,
        itemTypes: this.filters.length ? this.filters : null,
      })
      .subscribe((res) => {
        this.historyItems = res;
        this.updateCursors(res);
        this.pageStack = []; // reset stack
      });
  }

  nextPage() {
    if (!this.historyItems.length) return;

    this.pageStack.push({
      since: this.since,
      olderThan: this.olderThan,
    });

    const lastId = this.getLastItemId();

    this.callHistoryService
      .getCallHistory({
        limit: this.limit,
        olderThan: lastId,
        itemTypes: this.filters.length ? this.filters : null,
      })
      .subscribe((res) => {
        this.historyItems = res;
        this.updateCursors(res);
      });

    return false;
  }

  previousPage() {
    if (this.pageStack.length === 0) {
      this.loadInitial(); // fallback
      return;
    }

    const lastCursor = this.pageStack.pop(); // current page's cursor
    const prevCursor =
      this.pageStack.length > 0
        ? this.pageStack[this.pageStack.length - 1]
        : null;

    const since = this.getFirstItemId(); // first item on current page
    const olderThan = prevCursor?.olderThan; // the olderThan of the page before last

    this.callHistoryService
      .getCallHistory({
        limit: this.limit,
        since,
        olderThan,
        itemTypes: this.filters.length ? this.filters : null,
      })
      .subscribe((items) => {
        this.historyItems = items;
        this.updateCursors(items);
      });

    return false;
  }

  private updateCursors(items: (Calldto | Voicemaildto)[]) {
    if (items.length) {
      this.since = items[0].itemId!;
      this.olderThan = items[items.length - 1].itemId!;
    } else {
      this.since = this.olderThan = undefined;
    }
  }

  private getFirstItemId(): number | undefined {
    return this.historyItems.length > 0
      ? this.historyItems[0].itemId
      : undefined;
  }

  private getLastItemId(): number | undefined {
    return this.historyItems.length > 0
      ? this.historyItems[this.historyItems.length - 1].itemId
      : undefined;
  }

  toggleFilter(filter: string) {
    if (this.filters.includes(filter)) {
      this.filters = this.filters.filter((f) => f !== filter);
    } else {
      this.filters.push(filter);
    }
    //Re-fetch the call history with the new filters
    this.pageStack = [];
    this.loadInitial();
  }
}
